import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/rootStore";

export const OrderManager = observer(() => {
    const { bookingStore } = useStore();
    return (
        <div>
            <h4 className="fw-bold mb-4">Global Orders</h4>
            <div className="table-responsive">
                <table className="table align-middle">
                    <thead className="table-light">
                        <tr>
                            <th>Receipt</th>
                            <th>Status</th>
                            <th>Total</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {bookingStore.items.map(order => (
                            <tr key={order.id}>
                                <td>{order.receiptNumber}</td>
                                <td>
                                    <select 
                                        className="form-select form-select-sm w-auto"
                                        value={order.status}
                                        onChange={(e) => bookingStore.manage(order.id!, { status: e.target.value } as any)}
                                    >
                                        <option value="Pending">Pending</option>
                                        <option value="Shipped">Shipped</option>
                                        <option value="Delivered">Delivered</option>
                                        <option value="Cancelled">Cancelled</option>
                                    </select>
                                </td>
                                <td>Rs. {order.total}</td>
                                <td><button className="btn btn-sm btn-light border">View</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
});